import apiUrl from '../../../../../utils/settings';


export const AllInsurancesUrl = () => {
    return apiUrl + '/v2/benefit-beneficiary/all-insurances';
};
export const InsuranceDetailsUrl = () => {
    return apiUrl + '/v2/benefit-beneficiary/insurance-detail';
};
export const beneficiaryUrl = () => {
    return apiUrl + '/v2/benefit-beneficiary/beneficiary';
};
export const nomineeUrl = () => {
    return apiUrl + '/v2/benefit-beneficiary/nominee';
};
export const updateRelationUrl = () => {
    return apiUrl + '/v2/benefit-beneficiary/alternate-relations';
};
export const getPanCardImageUrl = () => {
    return apiUrl + '/benefit-beneficiary/beneficiary-pancard-image';
};
export const getBeneficiaryNomineeUrl = () => {
    return apiUrl + '/v2/benefit-beneficiary/beneficiary-nominee-details';
};
export const bankDetailsUrl = () => {
    return apiUrl + '/v2/benefit-beneficiary/beneficiary-bank-details';
};
export const NomineeRelationURL = () => {
    return apiUrl + '/v2/benefit-beneficiary/all-relations';
};
export const beneficiaryNomineeURL = () => {
    return apiUrl + '/v2/benefit-beneficiary/beneficiary-nominee';
};











